import { render, staticRenderFns } from "./PreviewOffer.vue?vue&type=template&id=5b32321c&"
import script from "./PreviewOffer.vue?vue&type=script&lang=js&"
export * from "./PreviewOffer.vue?vue&type=script&lang=js&"
import style0 from "./PreviewOffer.vue?vue&type=style&index=0&id=5b32321c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports